import { UserlogsService } from './shared/userlogs.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  logs: any = {};
  downloads: any = {};
  constructor(private userLogs: UserlogsService) { }


  ngOnInit() {
    this.userLogs.getLog().subscribe(res => { this.logs = res });
    this.userLogs.getDownloads().subscribe(res => { this.downloads = res });
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/dashboard/dashboard.component.ts